export const InsuranceList = ['10', '20', '50', '100', '200'];
